import {
  Toast,
  createToaster,
  type ToastData,
} from '@noorden-insurtech/alba-design-system';
import { withInactiveBrokerToastDedupe } from '@/shared/utils/inactive-broker-toast.util';

export const toaster = createToaster({
  placement: 'bottom-end',
  overlap: true,
  gap: 16,
  duration: 5000,
});

// Toast de corretora inativa é um só (id fixo): o BaseService já avisa a cada
// 403 e várias telas também criam o seu, com a mesma mensagem.
const createToast = toaster.create.bind(toaster);
toaster.create = (options: Parameters<typeof createToast>[0]) =>
  createToast(withInactiveBrokerToastDedupe(options));

export function Toaster() {
  return (
    <Toast.Toaster toaster={toaster}>
      {(toast: ToastData) => (
        <Toast.Root key={toast.id} type={toast.type}>
          {toast.title ? <Toast.Title>{toast.title}</Toast.Title> : null}
          {toast.description ? (
            <Toast.Description>{toast.description}</Toast.Description>
          ) : null}
        </Toast.Root>
      )}
    </Toast.Toaster>
  );
}
